module.exports = __webpack_public_path__ + "img/checked-icon.81998019.svg";